{
    "AutocalcdurationLabel": "Automatically Calculate Duration When Scheduling Report:",
    "BundleallemailattachinzipLabel": "Bundle All Email Attachments Inside A Zip File:",
    "RunandcollatewithsimilarschedLabel": "Run And Collate With Similar Periodic Report Schedules:",
    "NAME": "Advanced",
    "Advanced_SectionHeader": "Advanced"
}